// extracted by mini-css-extract-plugin
export default {"actions":"HireConfirmModalContent_actions__lp46b","normalButton":"HireConfirmModalContent_normalButton__U0uQf","ConfirmBtn":"HireConfirmModalContent_ConfirmBtn__YyWUP"};